import StringExtensions from "utils/stringExtensions";

/**
 * buildUrlPathName: Builds the pathname of the new url.
 * @param {string} subdirectory Segment related to the search subdirectory.
 * @param {string} location Segments related to the search location. 
 * @param {string} paging Segment related to the search page.
 * @returns An string with the pathname of the search.
 */
function buildUrlPathName(subdirectory, location, paging, builderName) {
  // The order to build the current search results url pathname is
  // subdirectory segment, then the location segments and finally the paging segment.
  const urlSegments = [];
  if(subdirectory) {
    urlSegments.push(subdirectory);
  }

  if(location) {
    urlSegments.push(location);
  }

  if(builderName) {
    urlSegments.push(builderName);
  }

  if (paging) {
    urlSegments.push(paging);
  }

  return urlSegments.join('/');
}

/**
 * buildNewUrl: Builds the entire url for the new search.
 * @param {object} config configuration object, it includes the following fields:
 * subdirectory, location, pagination, queryString, builderName.
 * @returns 
 */
function buildNewUrl(config) {
  const { urlSubdirectory, urlLocation, urlPaging, urlQueryString, urlBuilderName } = config;

  const newPathName = buildUrlPathName(urlSubdirectory, urlLocation, urlPaging, urlBuilderName);
  const newUrl = new URL(newPathName, window.location.origin);

  newUrl.search = urlQueryString;

  return newUrl;
}

/**
 * getPaging: Gets the paging segment for the search.
 * @param {Number} pageNumber Number of the selected page.
 * @returns The segment related to the paging of the current search.
 */
function getPaging(pageNumber) {
  // We only add the paging segment when the selected page is 2 or more.
  const shouldShowPagingOnUrl = pageNumber > 1;
  if (!shouldShowPagingOnUrl) {
    return '';
  }

  const newPaging = `page-${pageNumber}`;
  return newPaging;
}

/**
 * Returns a formatted brand name.
 *
 * @param {string} brandName - The name of the brand.
 * @param {number} brandId - The ID of the brand.
 * @returns {string} - The formatted brand name.
 */
function getBrandName(brandName, brandId) {
  if (!brandName || !brandId) {
    // If either brandName or brandId is not provided, return an empty string
    return '';
  }

  // Remove any special characters from the brandName
  const name = StringExtensions.encodeNameToUrl(brandName);

  // Return the formatted brand name with the builder prefix and brandId
  return `builder-${name}-${brandId}`;
}

export { buildNewUrl, getPaging, buildUrlPathName, getBrandName };